var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{attrs:{"value":_vm.promises.fetch}},[_c('Comments',_vm._g({attrs:{"value":_vm.comments,"promise":_vm.promises.comment},on:{"submit":_vm.comment}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }